import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../config/firebase';
const admin = httpsCallable(getFunctions(app, 'us-central1'), 'suiteAdmin');
export async function getPendingApprovalCount() {
  return (await admin({ action: 'pending-count' })).data.count;
}
export async function listUsers(cursor) {
  return (await admin({ action: 'list', ...(cursor ? { cursor } : {}) })).data;
}
export async function moderateUser(uid, action) {
  return (await admin({ uid, action })).data;
}
export async function setUserAccountType(uid, accountType) {
  return (await admin({ action: 'set-account-type', uid, accountType })).data;
}
export async function allocateUserTokens(uid, amount, allocationId) {
  return (await admin({ action: 'allocate-tokens', uid, amount, allocationId })).data;
}
